import { PanelProps } from '../Panel';

export const getPanelTransitionProps = (
  onOpenStart: PanelProps['onOpenStart'],
  onOpenComplete: PanelProps['onOpenComplete'],
  onCloseStart: PanelProps['onCloseStart'],
  onCloseComplete: PanelProps['onCloseComplete'],
  align: PanelProps['align'],
  animate: PanelProps['animate'],
  zIndex?: string | undefined,
  topOffset?: string | undefined
) => ({
  onOpenStart,
  onOpenComplete,
  onCloseStart,
  onCloseComplete,
  align,
  duration: animate ? undefined : 0,
  zIndex,
  topOffset,
});
